import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '../../../../../assets/images/likeicon01.png'
import _imports_1 from '../../../../../assets/images/likeicon02.png'
import _imports_2 from '../../../../../assets/images/likeicon03.png'
import _imports_3 from '../../../../../assets/images/likeicon04.png'
import _imports_4 from '../../../../../assets/images/reactions/allgreen.png'
import _imports_5 from '../../../../../assets/images/reactions/angrybull.png'
import _imports_6 from '../../../../../assets/images/reactions/diamondhand.png'
import _imports_7 from '../../../../../assets/images/reactions/deadweight.png'
import _imports_8 from '../../../../../assets/images/reactions/cryptomarket.png'
import _imports_9 from '../../../../../assets/images/reactions/crashingdown.png'
import _imports_10 from '../../../../../assets/images/reactions/crapmine.png'
import _imports_11 from '../../../../../assets/images/reactions/bloodbath.png'
import _imports_12 from '../../../../../assets/images/reactions/downchart.png'
import _imports_13 from '../../../../../assets/images/reactions/feelingsick.png'
import _imports_14 from '../../../../../assets/images/reactions/goldmine.png'
import _imports_15 from '../../../../../assets/images/reactions/kingofthemarket.png'
import _imports_16 from '../../../../../assets/images/reactions/queenofthemarket.png'
import _imports_17 from '../../../../../assets/images/reactions/sadbull.png'
import _imports_18 from '../../../../../assets/images/reactions/shock.png'
import _imports_19 from '../../../../../assets/images/reactions/shocked.png'
import _imports_20 from '../../../../../assets/images/reactions/smirkingbull.png'
import _imports_21 from '../../../../../assets/images/reactions/tothemood.png'
import _imports_22 from '../../../../../assets/images/reactions/upchart.png'


const _hoisted_1 = { class: "comment_box" }
const _hoisted_2 = { class: "comment_container" }
const _hoisted_3 = { class: "commentimgdetailcontainer" }
const _hoisted_4 = { class: "commentnameimgdetail" }
const _hoisted_5 = { class: "likeshareicon likeshareimgdetail leftExtraDv" }
const _hoisted_6 = {
  key: 0,
  href: "javascript:;"
}
const _hoisted_7 = {
  key: 1,
  href: "javascript:;"
}
const _hoisted_8 = {
  key: 2,
  href: "javascript:;"
}
const _hoisted_9 = {
  key: 3,
  href: "javascript:;"
}
const _hoisted_10 = {
  key: 4,
  href: "javascript:;"
}
const _hoisted_11 = {
  key: 5,
  href: "javascript:;"
}
const _hoisted_12 = {
  key: 6,
  href: "javascript:;"
}
const _hoisted_13 = {
  key: 7,
  href: "javascript:;"
}
const _hoisted_14 = {
  key: 8,
  href: "javascript:;"
}
const _hoisted_15 = {
  key: 9,
  href: "javascript:;"
}
const _hoisted_16 = {
  key: 10,
  href: "javascript:;"
}
const _hoisted_17 = {
  key: 11,
  href: "javascript:;"
}
const _hoisted_18 = {
  key: 12,
  href: "javascript:;"
}
const _hoisted_19 = {
  key: 13,
  href: "javascript:;"
}
const _hoisted_20 = {
  key: 14,
  href: "javascript:;"
}
const _hoisted_21 = {
  key: 15,
  href: "javascript:;"
}
const _hoisted_22 = {
  key: 16,
  href: "javascript:;"
}
const _hoisted_23 = {
  key: 17,
  href: "javascript:;"
}
const _hoisted_24 = {
  key: 18,
  href: "javascript:;"
}
const _hoisted_25 = {
  key: 19,
  href: "javascript:;"
}
const _hoisted_26 = {
  key: 20,
  href: "javascript:;"
}
const _hoisted_27 = {
  key: 21,
  href: "javascript:;"
}
const _hoisted_28 = {
  key: 22,
  href: "javascript:;"
}
const _hoisted_29 = ["innerHTML"]
const _hoisted_30 = { class: "caption" }
const _hoisted_31 = {
  key: 0,
  class: "like"
}
const _hoisted_32 = {
  key: 1,
  ref: "likeIconFooterRef",
  type: "button",
  class: "like clickable infoChangeButton"
}
const _hoisted_33 = ["onClick"]
const _hoisted_34 = ["src"]
const _hoisted_35 = {
  key: 0,
  class: "loader"
}
const _hoisted_36 = { class: "addClassDV" }
const _hoisted_37 = {
  key: 0,
  class: "reply_container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProfileAvatarComponent = _resolveComponent("ProfileAvatarComponent")!
  const _component_PostMetaComponent = _resolveComponent("PostMetaComponent")!
  const _component_PostMediaComponent = _resolveComponent("PostMediaComponent")!
  const _component_CommentItemComponent = _resolveComponent("CommentItemComponent", true)!
  const _component_CommentTextfieldComponent = _resolveComponent("CommentTextfieldComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createBlock(_component_ProfileAvatarComponent, {
      class: "small c-pointer",
      badges: false,
      border: true,
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToProfile())),
      key: _ctx.profilePicture,
      profileImage: _ctx.profilePicture
    }, null, 8, ["profileImage"])),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h6", null, _toDisplayString(_ctx.comment.fullName), 1),
          _createElementVNode("div", _hoisted_5, [
            (_ctx.showLikeIcon)
              ? (_openBlock(), _createElementBlock("a", _hoisted_6, _cache[9] || (_cache[9] = [
                  _createElementVNode("img", {
                    class: "emoicon01",
                    src: _imports_0
                  }, null, -1)
                ])))
              : _createCommentVNode("", true),
            (_ctx.showHeartIcon)
              ? (_openBlock(), _createElementBlock("a", _hoisted_7, _cache[10] || (_cache[10] = [
                  _createElementVNode("img", {
                    class: "emoicon02",
                    src: _imports_1
                  }, null, -1)
                ])))
              : _createCommentVNode("", true),
            (_ctx.showAppreciatedIcon)
              ? (_openBlock(), _createElementBlock("a", _hoisted_8, _cache[11] || (_cache[11] = [
                  _createElementVNode("img", {
                    class: "emoicon03",
                    src: _imports_2
                  }, null, -1)
                ])))
              : _createCommentVNode("", true),
            (_ctx.showKissIcon)
              ? (_openBlock(), _createElementBlock("a", _hoisted_9, _cache[12] || (_cache[12] = [
                  _createElementVNode("img", {
                    class: "emoicon04",
                    src: _imports_3
                  }, null, -1)
                ])))
              : _createCommentVNode("", true),
            (_ctx.showAllGreenIcon)
              ? (_openBlock(), _createElementBlock("a", _hoisted_10, _cache[13] || (_cache[13] = [
                  _createElementVNode("img", {
                    class: "emoicon04",
                    src: _imports_4
                  }, null, -1)
                ])))
              : _createCommentVNode("", true),
            (_ctx.showAngryBullIcon)
              ? (_openBlock(), _createElementBlock("a", _hoisted_11, _cache[14] || (_cache[14] = [
                  _createElementVNode("img", {
                    class: "emoicon04",
                    src: _imports_5
                  }, null, -1)
                ])))
              : _createCommentVNode("", true),
            (_ctx.showDiamondHandIcon)
              ? (_openBlock(), _createElementBlock("a", _hoisted_12, _cache[15] || (_cache[15] = [
                  _createElementVNode("img", {
                    class: "emoicon04",
                    src: _imports_6
                  }, null, -1)
                ])))
              : _createCommentVNode("", true),
            (_ctx.showDeadWeightIcon)
              ? (_openBlock(), _createElementBlock("a", _hoisted_13, _cache[16] || (_cache[16] = [
                  _createElementVNode("img", {
                    class: "emoicon04",
                    src: _imports_7
                  }, null, -1)
                ])))
              : _createCommentVNode("", true),
            (_ctx.showCryptoMarketIcon)
              ? (_openBlock(), _createElementBlock("a", _hoisted_14, _cache[17] || (_cache[17] = [
                  _createElementVNode("img", {
                    class: "emoicon04",
                    src: _imports_8
                  }, null, -1)
                ])))
              : _createCommentVNode("", true),
            (_ctx.showCrashingDownIcon)
              ? (_openBlock(), _createElementBlock("a", _hoisted_15, _cache[18] || (_cache[18] = [
                  _createElementVNode("img", {
                    class: "emoicon04",
                    src: _imports_9
                  }, null, -1)
                ])))
              : _createCommentVNode("", true),
            (_ctx.showCrapmineIcon)
              ? (_openBlock(), _createElementBlock("a", _hoisted_16, _cache[19] || (_cache[19] = [
                  _createElementVNode("img", {
                    class: "emoicon04",
                    src: _imports_10
                  }, null, -1)
                ])))
              : _createCommentVNode("", true),
            (_ctx.showBloodBathIcon)
              ? (_openBlock(), _createElementBlock("a", _hoisted_17, _cache[20] || (_cache[20] = [
                  _createElementVNode("img", {
                    class: "emoicon04",
                    src: _imports_11
                  }, null, -1)
                ])))
              : _createCommentVNode("", true),
            (_ctx.showDownChartIcon)
              ? (_openBlock(), _createElementBlock("a", _hoisted_18, _cache[21] || (_cache[21] = [
                  _createElementVNode("img", {
                    class: "emoicon04",
                    src: _imports_12
                  }, null, -1)
                ])))
              : _createCommentVNode("", true),
            (_ctx.showFeelingSickIcon)
              ? (_openBlock(), _createElementBlock("a", _hoisted_19, _cache[22] || (_cache[22] = [
                  _createElementVNode("img", {
                    class: "emoicon04",
                    src: _imports_13
                  }, null, -1)
                ])))
              : _createCommentVNode("", true),
            (_ctx.showGoldMineIcon)
              ? (_openBlock(), _createElementBlock("a", _hoisted_20, _cache[23] || (_cache[23] = [
                  _createElementVNode("img", {
                    class: "emoicon04",
                    src: _imports_14
                  }, null, -1)
                ])))
              : _createCommentVNode("", true),
            (_ctx.showKingOfTheMarketIcon)
              ? (_openBlock(), _createElementBlock("a", _hoisted_21, _cache[24] || (_cache[24] = [
                  _createElementVNode("img", {
                    class: "emoicon04",
                    src: _imports_15
                  }, null, -1)
                ])))
              : _createCommentVNode("", true),
            (_ctx.showQueenOfTheMarketIcon)
              ? (_openBlock(), _createElementBlock("a", _hoisted_22, _cache[25] || (_cache[25] = [
                  _createElementVNode("img", {
                    class: "emoicon04",
                    src: _imports_16
                  }, null, -1)
                ])))
              : _createCommentVNode("", true),
            (_ctx.showSadBullIcon)
              ? (_openBlock(), _createElementBlock("a", _hoisted_23, _cache[26] || (_cache[26] = [
                  _createElementVNode("img", {
                    class: "emoicon04",
                    src: _imports_17
                  }, null, -1)
                ])))
              : _createCommentVNode("", true),
            (_ctx.showShockIcon)
              ? (_openBlock(), _createElementBlock("a", _hoisted_24, _cache[27] || (_cache[27] = [
                  _createElementVNode("img", {
                    class: "emoicon04",
                    src: _imports_18
                  }, null, -1)
                ])))
              : _createCommentVNode("", true),
            (_ctx.showShockedIcon)
              ? (_openBlock(), _createElementBlock("a", _hoisted_25, _cache[28] || (_cache[28] = [
                  _createElementVNode("img", {
                    class: "emoicon04",
                    src: _imports_19
                  }, null, -1)
                ])))
              : _createCommentVNode("", true),
            (_ctx.showSmirkingBullIcon)
              ? (_openBlock(), _createElementBlock("a", _hoisted_26, _cache[29] || (_cache[29] = [
                  _createElementVNode("img", {
                    class: "emoicon04",
                    src: _imports_20
                  }, null, -1)
                ])))
              : _createCommentVNode("", true),
            (_ctx.showToTheMoodIcon)
              ? (_openBlock(), _createElementBlock("a", _hoisted_27, _cache[30] || (_cache[30] = [
                  _createElementVNode("img", {
                    class: "emoicon04",
                    src: _imports_21
                  }, null, -1)
                ])))
              : _createCommentVNode("", true),
            (_ctx.showUpChartIcon)
              ? (_openBlock(), _createElementBlock("a", _hoisted_28, _cache[31] || (_cache[31] = [
                  _createElementVNode("img", {
                    class: "emoicon04",
                    src: _imports_22
                  }, null, -1)
                ])))
              : _createCommentVNode("", true),
            _createElementVNode("p", null, _toDisplayString(_ctx.countReactions.length > 0 ? _ctx.countReactions.length : ""), 1)
          ])
        ]),
        _createElementVNode("p", {
          ref: "textElement",
          onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onClickText && _ctx.onClickText(...args)), ["stop"])),
          innerHTML: _ctx.formattedComment,
          class: "descriptive_text"
        }, null, 8, _hoisted_29),
        (_ctx.isTruncated && _ctx.visibleTextLength > _ctx.truncatedLength)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              class: "anchor_tag--more",
              onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.checkTextLength(false)), ["stop"]))
            }, "See More"))
          : (_ctx.visibleTextLength > _ctx.truncatedLength)
            ? (_openBlock(), _createElementBlock("a", {
                key: 1,
                class: "anchor_tag--more",
                onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.checkTextLength(true)), ["stop"]))
              }, "See Less"))
            : _createCommentVNode("", true),
        (_ctx.comment.metaData && _ctx.comment.metaData.length)
          ? (_openBlock(), _createBlock(_component_PostMetaComponent, {
              key: 2,
              meta: _ctx.comment.metaData
            }, null, 8, ["meta"]))
          : _createCommentVNode("", true),
        (_ctx.comment.media && _ctx.comment.media.length)
          ? (_openBlock(), _createBlock(_component_PostMediaComponent, {
              key: 3,
              media: _ctx.comment.media
            }, null, 8, ["media"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_30, [
        (_ctx.isPostLiked)
          ? (_openBlock(), _createElementBlock("span", _hoisted_31, [
              _createElementVNode("i", {
                class: "fas fa-thumbs-up active",
                onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.unlikePost()), ["stop"]))
              })
            ]))
          : (_openBlock(), _createElementBlock("button", _hoisted_32, [
              _cache[32] || (_cache[32] = _createElementVNode("i", { class: "far fa-thumbs-up" }, null, -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('common.actions.like')) + " ", 1),
              (!_ctx.isPostLiked)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    ref: "likeBoxRef",
                    class: "likeBox comment-like-box popover_content",
                    style: _normalizeStyle(_ctx.popoverStyle)
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reactions, (reaction) => {
                      return (_openBlock(), _createElementBlock("figure", {
                        key: reaction,
                        id: "pf_like",
                        onClick: _withModifiers(($event: any) => (_ctx.likePost($event, reaction)), ["stop"])
                      }, [
                        _createElementVNode("img", {
                          src: 
                  require(`../../../../../assets/images/reactions/${reaction}.png`)
                
                        }, null, 8, _hoisted_34)
                      ], 8, _hoisted_33))
                    }), 128))
                  ], 4))
                : _createCommentVNode("", true)
            ], 512)),
        (_ctx.comment?.userId === _ctx.userId)
          ? (_openBlock(), _createElementBlock("button", {
              key: 2,
              type: "button",
              class: "like clickable infoChangeButton",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.deleteComment(_ctx.comment._id, _ctx.allComments, _ctx.isComment)))
            }, [
              _createTextVNode(_toDisplayString(_ctx.$t('common.actions.delete')) + " ", 1),
              (_ctx.showDeleteLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_35))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (!_ctx.isReplyItem)
          ? (_openBlock(), _createElementBlock("button", {
              key: 3,
              type: "button",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showReply = !_ctx.showReply)),
              class: "clickable infoChangeButton"
            }, _toDisplayString(_ctx.$t('common.actions.reply')), 1))
          : _createCommentVNode("", true),
        _createElementVNode("p", _hoisted_36, _toDisplayString(_ctx.momentTime), 1)
      ]),
      (!_ctx.isReplyItem)
        ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
            (_ctx.comment.replies)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.comment.replies, (reply, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: reply._id
                    }, [
                      (_ctx.showAllReplies || index == 1)
                        ? (_openBlock(), _createBlock(_component_CommentItemComponent, {
                            key: 0,
                            sourceId: _ctx.sourceId,
                            sourceType: _ctx.sourceType,
                            postId: _ctx.postId,
                            comment: reply,
                            "is-comment": false,
                            "all-comments": _ctx.comment.replies
                          }, null, 8, ["sourceId", "sourceType", "postId", "comment", "all-comments"]))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128)),
                  (_ctx.comment.replies.length > 1 && !_ctx.showAllReplies)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        class: "outlineAnchor",
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showAllReplies = true))
                      }, "View More Replies"))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true),
            (_ctx.showReply)
              ? (_openBlock(), _createBlock(_component_CommentTextfieldComponent, {
                  key: 1,
                  sourceId: _ctx.comment._id,
                  isComment: false,
                  postId: _ctx.comment.sourceId,
                  userComment: _ctx.comment,
                  onHandleReplyInput: _cache[8] || (_cache[8] = ($event: any) => (_ctx.showReply = false))
                }, null, 8, ["sourceId", "postId", "userComment"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}